import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors } from '../Globals/styles';
import 'chart.js'
import {Doughnut as DoughnutChart} from '../../Scripts/react-chartjs/index';

class Pool extends Component{
  deviceScale = () => {
    /* for som reason mobile devices has to be divided by 4 to
        calc the center of the screen */
    return window.devicePixelRatio*2
  };
  onCanvasRedraw = () => {
    const { pool, registered } = this.props;
    var canvas = document.getElementsByTagName("CANVAS")[0];
    var ctx = canvas.getContext("2d");
    var isFinished = (pool - registered)===0;
    var font = styles.canvas.font;
    var fillStyle = styles.canvas.fillDef;
    var text = pool - registered;
    if (isFinished){
      fillStyle = semanticColors.success;
      text = "\uf00c"; //fa fa-check
      font = "35px FontAwesome";
    }
    if ((pool - registered) < 0){
      fillStyle =  semanticColors.danger
    }
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.textAlign = styles.canvas.textAlign;
    ctx.textBaseline = styles.canvas.verticalAlign;
    ctx.fillText(text, canvas.width/this.deviceScale(), canvas.height/this.deviceScale())
  };
  getRegisteredVal = () => {
    const { pool, registered } = this.props;
    //force the doghnut to be green in this case
    if (pool===0 && registered===0)
      return 100
    return registered
  };
  calculateRemainingHours = () => {
    const { pool, registered } = this.props;
    var remainingHours = pool - registered;
    return remainingHours <= 0 ? 0 : remainingHours
  };

  render()  {
    const { pool, registered } = this.props;
    return (
      <DoughnutChart
        style={styles.canvas}
        data={[
        {
            value: (pool - registered < 0) ? 0 : this.getRegisteredVal(),
            color:semanticColors.success,
            highlight: "#5AD3D1",
            label: "Registreret"
        },
        {
            value: (pool - registered < 0) ? 0 : this.calculateRemainingHours(),
            color: semanticColors.warning,
            highlight: "#FFC870",
            label: "Timepulje"
        },
        {
            value: (pool - registered < 0) ? 100 : 0,
            color: semanticColors.danger
        }
        ]}
        options={{
            animation: false,
            percentageInnerCutout : 78,
            responsive: true,
            showTooltips: false,
            onAnimationComplete : ()=>{this.onCanvasRedraw()}
          }
        }/>
    );
  }
}

var styles = {
  canvas: {
    font : "bold 24px Open Sans",
    fillDef : semanticColors.text,
    fillRed : semanticColors.danger,
    fillSuccess: semanticColors.success,
    textAlign : "center",
    verticalAlign: "middle"
  }
}
  Pool.propTypes = {
    pool: PropTypes.number.isRequired,
    registered: PropTypes.number.isRequired
  };
export default Radium(Pool);


// WEBPACK FOOTER //
// ./src/App/Common/poolChart.jsx